import { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const WebLayout = ({ children }) => {
    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const updateHeaderHeight = () => {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight);
            }
        };

        updateHeaderHeight();

        const resizeObserver = new ResizeObserver(updateHeaderHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header ref={headerRef} />
            <Box
                component='main'
                sx={{
                    pt: `${headerHeight}px`,
                    flexGrow: 1
                }}
            >
                {children}
            </Box>
            <Footer />
        </Box>
    );
};

export default WebLayout;
